module.exports = __webpack_public_path__ + "img/card06.6724f373.png";